<!-- Legend -->
<Label id="legend" class="legend"></Label>
<!-- Loading Spinner -->
<img class="progress-spinner rotate" *ngIf="loading" src="assets/loading.png" alt="loading...">
<!-- Main Chart Area -->
<figure id="matrix" [ngStyle]="{'width':'100%','height':figureHeight}"></figure>

